export function logosSlider() {
    const $logoSlider = $(".logos-slider");
    const $prev = `
    <button type="button" class="arrow-button slick-prev">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.36459 12.0924L7.72819 11.456L11.7343 7.44993L1.1765 7.44993L1.1765 6.55261L11.7343 6.55262L7.72819 2.5465L8.36459 1.9101L13.4558 7.00127L8.36459 12.0924Z" fill="#111111"/>
        </svg>
    </button>`;
    const $next = ` 
    <button type="button" class="arrow-button slick-next">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.36459 12.0924L7.72819 11.456L11.7343 7.44993L1.1765 7.44993L1.1765 6.55261L11.7343 6.55262L7.72819 2.5465L8.36459 1.9101L13.4558 7.00127L8.36459 12.0924Z" fill="#111111"/>
      </svg>
    </button>`;
    $logoSlider.slick({
        slidesToShow: 2.5,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        mobileFirst: true,
        infinite: false,
        prevArrow: $prev,
        nextArrow: $next,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: false
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    arrows: false
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    arrows: true
                }
            },
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    arrows: true
                }
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js